<script lang="ts">
import { library } from "@voodoo.io/fortawesome/fontawesome-svg-core";
// eslint-disable-next-line import/order
import { far } from "@voodoo.io/fortawesome/pro-regular-svg-icons";

library.add(far);
</script>

<script setup lang="ts">
import { FontAwesomeIcon } from "@voodoo.io/fortawesome/vue-fontawesome";
import { computed } from "vue";

const props = defineProps({
  /**
   * The store used for the icon. For now, only 2 stores are supported:
   *  - fontawesome (fa)
   *  - custom voodoo (vd)
   */
  store: {
    type: String,
    validator: (value: string) => ["fa", "far", "fas"].includes(value),
    default: "fa", // fa = fontawesome, vd = voodoo
  },

  /**
   * The name of the icon (from the store)
   */
  name: {
    type: String,
    required: true,
  },

  /**
   * The different size of the icon that match the size of the button
   */
  size: {
    // small, default, large
    type: String,
    default: "default",
  },

  /**
   * The color of the icon (must be a valid css color or var)
   */
  color: {
    type: String,
    default: "var(--vd-icon-color)",
  },

  customSize: {
    type: String,
    default: null,
  },
});

const faStore = computed(() => (props.store === "fa" ? "far" : props.store));
</script>

<template>
  <FontAwesomeIcon
    :class="['vd-icon', `vd-icon--size--${size}`, $attrs.class]"
    :style="{ fontSize: customSize }"
    v-bind="$attrs"
    :icon="[faStore, name]"
    :color="color"
  />
</template>

<style lang="scss">
.vd-icon {
  font-size: 14px;

  &.vd-icon--size--small {
    font-size: 12px;
  }

  &.vd-icon--size--large {
    font-size: 16px;
  }
}
</style>
